/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention */ // Translation keys use snake_case

import { RawTranslations } from '@repo/types';

const translations: RawTranslations = {
    // Native membership
    choose_another_card: 'Roghnaigh cárta eile',
    use_auto_selection: 'Úsáid roghnú uathoibríoch',
    split_into_groups: 'Roinn i ngrúpaí',
    add_group: 'Cuir grúpa leis',
    merge_back_to_auto: 'Cumaisc ar ais go huathoibríoch',
    remove_group: 'Bain grúpa',
    cards: 'cártaí',
    tickets: 'ticéid',
    remaining_on_auto: 'Clúdaítear an chuid eile go huathoibríoch',
    member_card_not_applicable: 'Níl sé infheidhme',
    group_label: 'Grúpa',
    have_account_or_member_card: 'An bhfuil cuntas nó cárta ball agat?',
    member_card_coverage_failed: 'Níorbh fhéidir do chártaí ball a chur i bhfeidhm.',
    retry: 'Bain triail eile as',
    your_member_cards: 'Do chártaí ball',
    pay_with_money_instead: 'Íoc le hairgead ina ionad',
    member_card_purchased: 'Ceannach críochnaithe',
    start_date: 'Dáta tosaigh',
    my_page: 'Mo leathanach',
    password: 'Pasfhocal',
    forgot_password: 'An ndearna tú dearmad ar do phasfhocal?',
    member_login_subtitle: 'Sign in to your membership account',
    member_signup_subtitle: 'Create your membership account',
    register: 'Sign up',
    create_account: 'Create account',
    become_member: 'Become a member',
    confirm_password: 'Confirm password',
    need_help: 'Need help?',
    and: 'and',
    passwords_do_not_match: 'Passwords do not match',
    password_too_short: 'Password must be at least 8 characters',
    invalid_phone_format: 'Enter a valid phone number (e.g. +4791234567)',
    email_already_registered: 'This email is already registered',
    registration_failed: 'Registration failed. Please try again.',
    forgot_password_email_sent:
        'Má tá an seoladh ríomhphoist sin cláraithe, gheobhaidh tú nasc athshocraithe go luath.',
    wrong_email_or_password: 'Ríomhphost nó pasfhocal mícheart',
    member_session_expired: 'Tá do sheisiún imithe in éag. Logáil isteach arís.',
    show_password: 'Taispeáin pasfhocal',
    hide_password: 'Folaigh pasfhocal',
    show_cancellation_policy: 'Taispeáin Polasaí Cealaithe',
    hide_cancellation_policy: 'Folaigh Polasaí Cealaithe',
    departure: 'Imeacht',
    price: 'Praghas',
    difficulty: 'Deacracht',
    duration: 'Fad',
    starting_time: 'Am tosaigh',
    about: 'Faoi',
    book_now: 'Áirigh anois',
    book: 'Áirigh',
    buy_as_gift: 'ceannaigh mar bhronntanas',
    from: 'Praghas ó',
    your_booking_reference_is: 'is é do thagairt áirithinte',
    booking_details_in_email: 'gheobhaidh tú ríomhphost le tuilleadh eolais go luath',
    see_more_activities: 'Féach ar ghníomhaíochtaí breise',
    your_cart: 'Do thralaí',
    in_your_cart: 'I do thralaí',
    when_are_you_going: 'Roghnaigh dáta agus am',
    how_many_are_going: 'Cé mhéad atá ag dul?',
    contact_details: 'Sonraí teagmhála',
    traveler: 'Taistealaí',
    extras: 'Breiseáin',
    please_select: 'Roghnaigh le do thoil',
    no_items_in_cart: 'Níl aon earraí i do thralaí siopadóireachta',
    payment: 'Íocaíocht',
    receipt: 'Admháil',
    do_you_have_any_comments_or_special_needs:
        'An bhfuil aon tuairimí nó riachtanais speisialta agat?',
    i_have_read_and_accepted_the: 'Tá léite agam agus glacaim leis an',
    privacy_policy: 'Polasaí príobháideachta',
    terms_and_conditions: 'Téarmaí agus coinníollacha',
    must_accept_privacy_policy:
        'Caithfidh tú glacadh leis an bPolasaí Príobháideachta chun leanúint ar aghaidh',
    must_accept_terms_and_conditions:
        'Caithfidh tú glacadh leis na Téarmaí agus Coinníollacha chun leanúint ar aghaidh',
    first_name: 'Ainm baiste',
    last_name: 'Sloinne',
    phone_number: 'Uimhir fóin',
    dial_code: 'Cód dialála',
    email: 'Ríomhphost',
    is_required: 'riachtanach',
    please_register: 'Cláraigh le do thoil',
    main_contact: 'Príomhtheagmhálaí',
    additional_information: 'Eolas breise',
    remove_cart_item: 'Bain earra tralaí',
    excl: 'gan.',
    vat: 'CBL',
    total: 'Iomlán',
    payNow: 'Íoc anois',
    payLater: 'Íoc níos déanaí',
    only_deposit_amount_to_pay_now: {
        template: 'Níl ach <NAME> mar éarlais le híoc anois.',
    } as any,
    next: 'Ar aghaidh',
    go_and_pay: 'Téigh agus íoc',
    confirm_booking: 'Deimhnigh áirithint',
    no_payment_required: 'Níl íocaíocht ag teastáil',
    print: 'Priontáil',
    close: 'Dún',
    checkout: 'Seiceáil amach',
    summary: 'Achoimre',
    cancel: 'Cealaigh',
    save: 'Sábháil',
    select_time: 'Roghnaigh am',
    selected_time: 'Am roghnaithe',
    time: 'Am',
    go_back: 'Téigh ar ais',
    thank_you_for_booking_with_us: 'Go raibh maith agat as áirithint linn!',
    please_fill_in_all_required_information:
        'Líon isteach an t-eolas riachtanach ar fad le do thoil',
    error_occurred_when_creating_reservation: 'Tharla earráid agus áirithint á cruthú',
    error_occurred_when_creating_giftcard: 'Tharla earráid agus cárta bronntanais á chruthú',
    couldnt_apply_promocode_is_the_code_correct:
        'Níorbh fhéidir an cód fóntais a chur i bhfeidhm. An bhfuil an cód ceart?',
    choose_a_country: 'Roghnaigh tír',
    select_date: 'Roghnaigh dáta',
    select_travelers: 'Roghnaigh taistealaithe',
    hourShort: 'u',
    dayShort: 'l',
    minuteShort: 'n',
    years: 'blianta',
    age: 'Aois',
    more_information: 'Tuilleadh eolais',
    same_as_main_contact: 'Mar an gcéanna leis an bpríomhtheagmhálaí',
    easy: 'Éasca',
    medium: 'Meánach',
    hard: 'Deacair',
    please_select_date: 'Roghnaigh dáta le do thoil',
    please_select_date_and_time: 'Roghnaigh dáta agus am le do thoil',
    name: 'Ainm',
    comment: 'Trácht',
    submit_request: 'Cuir iarratas isteach',
    any_special_requests_etc: 'Aon iarratais speisialta, ailléirgí bia...?',
    request_tour_comment: "Déan cur síos ar d'iarratas",
    thank_you_for_your_request:
        "Go raibh maith agat as d'iarratas, beidh muid ar ais chugat ar luas lasrach.",
    got_it: 'Tuigim!',
    continue_shopping: 'Lean ar aghaidh ag siopadóireacht',
    continue_travelers: 'Taistealaithe',
    please_provide_your_name: 'Tabhair ainm le do thoil',
    please_provide_your_email: 'Tabhair ríomhphost bailí le do thoil',
    please_provide_a_description: 'Tabhair cur síos le do thoil',
    an_error_occurred_when_submitting_your_request:
        "Tharla earráid agus d'iarratas á chur isteach. Déan iarracht arís níos déanaí le do thoil.",
    private_tour: 'Turas príobháideach',
    read_more_and_book: 'Léigh níos mó & áirigh',
    read_more: 'Léigh níos mó',
    prices_from: 'Praghsanna ó',
    about_the_trip: 'Faoin turas',
    prices: 'Praghsanna',
    whats_included: 'Cad atá san áireamh',
    any: 'Aon cheann',
    duration_up_to_1_hour: 'Suas le 1 uair',
    duration_1_2_hours: '1 - 2 uair',
    duration_2_6_hours: '2 - 6 uair',
    duration_6_12_hours: '6 - 12 uair',
    duration_12_24_hours: '12 - 24 uair',
    duration_1_2_days: '1 - 2 lá',
    duration_more_than_2_days: 'Níos mó ná 2 lá',
    find_activities: 'Aimsigh gníomhaíochtaí',
    ok: 'OK',
    clear: 'Glan',
    filterActivities: 'Scag gníomhaíochtaí',
    hideFilters: 'Folaigh scagairí',
    shopMore: 'Siopadóireacht breise',
    noSearchResults:
        "Tá brón orainn, níor aimsíomar aon ghníomhaíochtaí ar fáil a mheaitseálann d'fhiosrúchán.",
    update: 'Nuashonrú',
    select_date_to_view_timeslots: 'Roghnaigh dáta chun slotanna ama ar fáil a fheiceáil',
    your_reservation_timed_out: "Tháinig d'áirithint chun deiridh. Déan iarracht arís le do thoil.",
    aria_calendar_input_field_label: 'Ionchur féilire. Brúigh Enter chun oscailt.',
    aria_book_now_button: 'Oscail fuinneog chun an ghníomhaíocht seo a áirithint',
    aria_next_image: 'Íomhá chéad',
    aria_previous_image: 'Íomhá roimhe seo',
    aria_open_booking_widget: 'Oscail fuinneog áirithinte',
    aria_close_booking_widget: 'Dún fuinneog áirithinte',
    aria_go_to_home: 'Téigh go dtí an baile',
    aria_checkout_steps: 'Céimeanna seiceála amach',
    aria_order_summary: 'Achoimre ordaithe',
    expanded: 'leathnaithe',
    collapsed: 'comhbhrúite',
    aria_open_request_tour_widget: 'Oscail fuinneog iarratais turas',
    aria_close_request_tour_widget: 'Dún fuinneog iarratais turas',
    aria_open_find_activity: 'Oscail aimsigh gníomhaíocht',
    aria_close_find_activity: 'Dún aimsigh gníomhaíocht',
    aria_show_giftcard_input: 'Taispeáin réimse cárta bronntanais',
    aria_hide_giftcard_input: 'Folaigh réimse cárta bronntanais',
    fill_giftcard_code: 'Cuir isteach cód cárta bronntanais',
    aria_show_promocode_input: 'Taispeáin réimse cód fóntais',
    aria_hide_promocode_input: 'Folaigh réimse cód fóntais',
    aria_price_to_pay_summary: 'Achoimre ar phraghas le híoc',
    vat_breakdown: 'Miondealú CBL',
    fill_promocode: 'Cuir isteach cód fóntais',
    request_tour: 'iarratas turas',
    giftcard_message: 'teachtaireacht',
    giftcard_message_label: 'teachtaireacht phearsanta don fhaighteoir (roghnach)',
    recipient_details: 'sonraí faighteora',
    gift_card: 'cárta bronntanais',
    value: 'luach',
    create: 'cruthaigh',
    create_your_gift: 'cruthaigh do chárta bronntanais',
    your_giftcard_reference_is: 'is é do thagairt',
    giftcard_voucher_and_receipt:
        'tá voucher bronntanais réidh le priontáil curtha chugat chomh maith le admháil chuig:',
    giftcard_voucher: 'tá an voucher bronntanais curtha chuig:',
    giftcard_and_receipt: 'agus admháil chugatsa ag:',
    thank_you_for_your_purchase: 'go raibh maith agat as do cheannach!',
    valid_until: 'bailí go dtí',
    print_receipt: 'priontáil admháil',
    select_gift_type: 'roghnaigh cineál bronntanais',
    please_select_gift_type: 'roghnaigh cineál bronntanais le do thoil',
    select_gift_print_description: 'faigh cárta bronntanais PDF inphriontáilte i do bhosca isteach',
    select_gift_email_description:
        'seol cárta bronntanais trí ríomhphost go díreach chuig an bhfaighteoir',
    enter_giftcard_code: 'Cuir isteach cód cárta bronntanais',
    enter_promo_code: 'Cuir isteach cód fóntais',
    apply: 'cuir i bhfeidhm',
    giftcard_code_error: 'cód cárta bronntanais neamhbhailí',
    remaining_value: 'luach atá fágtha',
    giftcard_code_not_found: 'níorbh fhéidir cárta bronntanais a aimsiú leis an gcód:',
    giftcard_zero_balance: 'tá an cárta bronntanais caite cheana féin',
    giftcard_is_expired: 'tá an cárta bronntanais as feidhm',
    purchased_giftcard: {
        self: 'cárta bronntanais inphriontáilte curtha chugat',
        recipient: 'cárta bronntanais inphriontáilte curtha chuig an bhfaighteoir',
    },
    contact_information: {
        short: 'eolas teagmhála',
        long: 'eolas teagmhála',
    },
    minutes: {
        singular: 'nóim',
        plural: 'nóim',
        long: 'nóiméad',
    },
    hours: {
        singular: 'uair',
        plural: 'uaireanta',
    },
    days: {
        singular: 'lá',
        plural: 'laethanta',
    },
    children: {
        singular: 'páiste',
        plural: 'páistí',
    },
    adult: {
        singular: 'duine fásta',
        plural: 'daoine fásta',
    },
    card: {
        singular: 'cárta',
        plural: 'cártaí',
    },
    too_few_travelers: 'Ró-bheag rannpháirtithe',
    too_few_travelers_quantity: {
        template: 'Is gá <COUNT:ticket:tickets> ar a laghad an lá seo',
    } as any,
    number_of_travelers_exceeded: {
        template: 'Uasmhéid <COUNT:ticket:tickets> ar fáil an lá seo',
    } as any,
    booking_is_closed: {
        template: 'Tá áirithint do <NAME> dúnta anois',
    } as any,
    rooms: {
        singular: 'seomra',
        plural: 'seomraí',
    },
    person: {
        singular: 'duine',
        plural: 'daoine',
    },
    select_room: 'roghnaigh seomra',
    change_room: 'athraigh seomra',
    less_than: 'níos lú ná',
    year: {
        singular: 'bliain',
        plural: 'blianta',
    },
    select_age: 'roghnaigh aois',
    done: 'déanta',
    number_of_rooms: 'líon na seomraí',
    select_bed: 'roghnaigh leaba',
    room_info: 'eolas seomra',
    price_one_night_one_guest: {
        template: 'praghas ar feadh <COUNT:night:nights>, <COUNT:guest:guests>',
    } as any,
    one_night_one_guest: {
        template: '<COUNT:night:nights>, <COUNT:guest:guests>',
    } as any,
    price_nights: {
        template: 'praghas ar feadh <COUNT:night:nights>',
    } as any,
    night: {
        singular: 'oíche',
        plural: 'oícheanta',
    },
    select_room_for_total_price: 'roghnaigh seomraí chun praghas iomlán a fháil',
    find_rooms: 'aimsigh seomraí',
    check_in_check_out: 'Clárú isteach agus Clárú amach',
    guest_and_rooms: 'Aíonna agus seomraí',
    no_accommodations_found:
        'Tá brón orainn, ach níorbh fhéidir linn aon seomraí a aimsiú a mheaitseálann do chritéir chuardaigh. Ar smaoinigh tú ar do pharaiméadair chuardaigh a choigeartú chun seomraí ar fáil a aimsiú?',
    facilities_included: 'Áiseanna san áireamh',
    price_per_night: 'Praghas in aghaidh na hoíche',
    season: 'Séasúr',

    has_airconditioning: 'Aerchoigeartú',
    has_balcony: 'Balcóin',
    has_bicycles: 'Rothair',
    has_boat: 'Bád',
    has_coffee_maker: 'Déantóir caife',
    has_dishwasher: 'Mála níocháin',
    has_dryer: 'Tirimire',
    has_fireplace: 'Teallach',
    has_garage: 'Garáiste',
    has_garden_furniture: 'Troscán gairdín',
    has_grill: 'Griall',
    has_kitchen: 'Cistin',
    has_minibar: 'Minibar',
    has_mooring_space: 'Spás feistithe',
    has_pool: 'Linn snámha',
    has_roomservice: 'Seirbhís Seomra',
    has_sauna: 'Sauna',
    has_tv: 'Teilifís',
    has_washing_machine: 'Meaisín Níocháin',
    has_wifi: 'WiFi',
    is_breakfast_included: 'Bricfeasta',
    is_cancellation_included: 'Féidearthacht cealaithe',
    is_pets_allowed: 'Peataí ceadaithe',
    is_smoking_allowed: 'Caitheamh tobac ceadaithe',
    is_towels_and_bedlines_included: 'Tuáillí agus línte leapa',
    is_wheelchair_accessible: 'Inrochtana le cathaoir rothaí',
    wifi: 'WiFi',
    breakfast: 'Bricfeasta',
    accessible: 'Inrochtana',
    pets: 'Peataí',
    kitchen: 'Cistin',
    smoking: 'Caitheamh tobac',
    unknown: 'Anaithnid',
    accommodation_cancellation_policy: '',
    accommodations: 'Lóistín',
    activities: 'Gníomhaíochtaí',
    address: 'seoladh',
    city: 'cathair',
    post_code: 'cód poist',
    to: 'chuig',
    date_range_start: 'tús',
    date_range_end: 'deireadh',
    flag_of: 'bratach',
    monday: 'Luan',
    tuesday: 'Máirt',
    wednesday: 'Céadaoin',
    thursday: 'Déardaoin',
    friday: 'Aoine',
    saturday: 'Satharn',
    sunday: 'Domhnach',
    today: 'inniu',
    tomorrow: 'amárach',
    january: 'Eanáir',
    february: 'Feabhra',
    march: 'Márta',
    april: 'Aibreán',
    may: 'Bealtaine',
    june: 'Meitheamh',
    july: 'Iúil',
    august: 'Lúnasa',
    september: 'Meán Fómhair',
    october: 'Deireadh Fómhair',
    november: 'Samhain',
    december: 'Nollaig',
    few_left: 'cúpla fágtha',
    tickets_left: {
        template: '<COUNT:ticket:tickets> fágtha',
    } as any,
    available: 'ar fáil',
    sold_out: 'díolta amach',
    upcoming_tours_title: 'Turais atá le teacht',
    unavailable: 'Níl ar fáil',
    notes_regarding_your_stay: "Nótaí maidir le d'fhanacht",
    notes_for_accommodation_name_with_guests: {
        template: 'Nótaí do <NAME> le <COUNT:guest:guests>',
    } as any,
    select_price_type: 'Roghnaigh cineál praghais',
    tour_option: 'Rogha turais',
    finding_available_rooms: 'Ag aimsiú seomraí ar fáil',
    loading_availability: 'Infhaighteacht á lódáil...',
    total_price: 'Praghas iomlán',
    of: 'de',
    select_dates: 'Roghnaigh dátaí',
    please_select_price_type: 'Roghnaigh cineál praghais le do thoil',
    a_minimum_of_participants_is_required_to_book_this_product:
        'Tá líon íosta rannpháirtithe ag teastáil chun an táirge seo a áirithint.',
    a_minimum_of_x_participants_is_required_to_book_this_product: {
        template: `Tá íosmhéid <COUNT> rannpháirtithe ag teastáil chun an táirge seo a áirithint`,
    } as any,
    aBookingConfirmationWillBeSentToYourEmailAddressAsSoonAsWeHaveProcessedYourOrder:
        "Cuirfear deimhniú áirithinte chuig d'seoladh ríomhphoist chomh luath agus a bheidh d'ordú próiseáilte againn.",
    aConfirmationWillBeSentToYourEmailAddressAsSoonAsWeHaveProcessedYourOrder:
        "Cuirfear deimhniú chuig d'seoladh ríomhphoist chomh luath agus a bheidh d'ordú próiseáilte againn.",
    add: 'Cuir leis',
    amount: 'Méid',
    areYouAMemberOrHaveValueCard: 'An bhfuil tú ina bhall, nó an bhfuil cárta luacha agat?',
    areYouSureYouWantToCancelYourBooking:
        'An bhfuil tú cinnte gur mhaith leat an t-áirithint seo a chealú?',
    areYouSureYouWantToCancelYourMembership:
        "An bhfuil tú cinnte gur mhaith leat d'bhallraíocht a chealú?",
    automaticallyRenewed: 'Athnuachan go huathoibríoch',
    at: 'Ag',
    backToWebsite: 'Ar ais chuig an láithreán gréasáin',
    belayCertification: 'Deimhniú belay',
    belayCertificationConsent: 'Tá deimhniú belay agam',
    buyMembership: 'Ceannaigh ballraíocht',
    buyNow: 'Ceannaigh anois',
    cancelled: 'Cealaithe',
    canBeCancelledFrom: 'Is féidir a chealú ó',
    choose_payment_method: 'Roghnaigh modh íocaíochta',
    bookNow: 'Ceannaigh anois',
    bookTimeslot: 'Ceannaigh ticéid',
    cancellation: 'Cealú',
    choose: 'Roghnaigh',
    chooseACountry: 'Roghnaigh tír',
    chooseCreditsType: 'Roghnaigh cineál creidmheasanna',
    chooseDateAndTime: 'Roghnaigh dáta agus am',
    chooseNumberOfCredits: 'Roghnaigh líon na gcreidmheasanna',
    chooseStartDate: 'Roghnaigh dáta tosaigh',
    chooseType: 'Roghnaigh cineál',
    ticketCode: 'Tagairt ordú',
    completed: 'Críochnaithe',
    consents: 'Toilithe',
    contact: 'Teagmháil',
    contactByEmail: 'Teagmháil trí Ríomhphost',
    contactBySms: 'Teagmháil trí SMS',
    couldntApplyGiftcardIsTheCodeCorrect:
        'Níorbh fhéidir an cárta bronntanais a chur i bhfeidhm. An bhfuil an cód ceart?',
    couldntApplyPromocodeIsTheCodeCorrect:
        'Níorbh fhéidir an cód fóntais a chur i bhfeidhm. An bhfuil an cód ceart?',
    promocodeIsNotCompatibleWithCart:
        'Níl an cód fóntais seo comhoiriúnach le do tháirgí roghnaithe.',
    couldntGetCompanyInformation: 'Níorbh fhéidir eolas an chomhlachta a fháil',
    couldntGetPaymentPlan:
        'Níorbh fhéidir plean íocaíochta a fháil. Déan iarracht ar an leathanach gréasáin a athnuachan le do thoil.',
    couldntGetPaymentPlanUsingPreviousPlan:
        'Níorbh fhéidir plean íocaíochta a fháil, ag úsáid an phlean roimhe seo',
    couldntGetValueCards: 'Níorbh fhéidir cártaí luacha a fháil',
    couldntGetValueCardProducts: 'Níorbh fhéidir táirgí cárta luacha a fháil',
    couldntGetProductPleaseTryAgain:
        'Níorbh fhéidir táirge a fháil, déan iarracht arís le do thoil',
    couldntOpenBookingCheckoutNotAllBookingInformationHasBeenSet:
        'Níorbh fhéidir seiceáil amach áirithinte a oscailt, níl an t-eolas áirithinte riachtanach ar fad sonraithe.',
    couldntOpenProfilePleaseSignInFirst:
        'Níorbh fhéidir próifíl a oscailt, sínigh isteach ar dtús le do thoil.',
    couldntOpenValueCardCheckoutNotAllValueCardInformationHasBeenSet:
        'Níorbh fhéidir seiceáil amach cárta luacha a oscailt, níl an t-eolas cárta luacha riachtanach ar fad sonraithe.',
    country: 'Tír',
    createAccount: 'Cruthaigh cuntas',
    credit: {
        singular: 'Creidmheas',
        plural: 'Creidmheasanna',
    },
    credits: 'Creidmheasanna',
    creditsLeft: 'Creidmheasanna fágtha',
    creditDiscount: 'Lascaine creidmheasa',
    discount: 'Lascaine',
    free: 'Saor',
    date: 'Dáta',
    delete: 'Scrios',
    doYouHaveAnAccount: 'An bhfuil cuntas agat?',
    doYouHaveValueCards: 'An bhfuil cuntas agat, nó aon chártaí luacha?',
    doYouHaveBrattkort: 'An bhfuil Brattkort nó deimhniú belay agat?',
    doYouHaveClimbingCertification: 'An bhfuil deimhniú dreapadóireachta agat?',
    edit: 'Cuir in eagar',
    editTimeslot: 'Cuir slot ama in eagar',
    failed: 'Theip',
    firstName: 'Ainm baiste',
    giftcard: 'Cárta bronntanais',
    goToMyPage: 'Téigh chuig mo leathanach',
    ifYouWantToDeleteYourProfile: 'Má theastaíonn uait do phróifíl a scriosadh',
    youCanPurchaseBookingsFromTheShopOnThisWebsite:
        'Is féidir leat ticéid a cheannach ón siopa ar an láithreán gréasáin seo.',
    yourOrderReferenceIs: 'Is é do thagairt ordú',
    iHaveReadAndAccepted: 'Tá léite agam agus glacaim leis an',
    lastName: 'Sloinne',
    postalLocation: 'Suíomh',
    location: 'Suíomh',
    loggedInAs: 'Sínithe isteach mar',
    login: 'Sínigh isteach',
    logout: 'Sínigh amach',
    membershipCard: 'Ballraíocht',
    membershipNumber: 'Uimhir ballraíochta',
    membershipSlashCredits: 'Ballraíocht / Creidmheasanna',
    myAddress: 'Mo sheoladh',
    myPage: 'Mo leathanach',
    myProfile: 'Mo phróifíl',
    nextCreateAccount: 'Ar aghaidh: Cruthaigh cuntas',
    no: 'Ní hea',
    noneSelected: 'Níl aon cheann roghnaithe',
    noSelectedDate: 'Níl aon dáta roghnaithe',
    notAllFieldsHaveBeenFilledPleaseFillAllFields:
        'Níl na réimsí ar fad líonta, tabhair na réimsí ar fad le do thoil.',
    noUserInfoFound: 'Níor aimsíodh aon eolas úsáideora.',
    numberOfPersons: {
        singular: 'duine',
        plural: 'daoine',
        template: '<COUNT:person:daoine>',
    } as any,
    pay: 'Íoc',
    payWithCreditCard: 'Íoc le cárta creidmheasa',
    phoneNumber: 'Uimhir fóin',
    pleaseChoose: 'Roghnaigh le do thoil',
    pleaseContact: 'Déan teagmháil le do thoil',
    pleaseFillOutUserInfoInProfile: 'Líon amach eolas úsáideora i do phróifíl le do thoil.',
    pleaseLogInToBook: 'Sínigh isteach le do thoil chun ceannach leis na cinn seo',
    pleaseLogInToPurchase: "Sínigh isteach le do thoil agus líonfaimid d'eolas teagmhála duit",
    pleaseProvideAllValueCardInformation: 'Tabhair eolas cárta luacha ar fad le do thoil',
    pleaseProvideProperBookingInformation: 'Tabhair eolas bailí le do thoil',
    pleaseRegister: 'Cláraigh le do thoil',
    postalCodeAndLocation: 'Cód poist / suíomh',
    prefix: 'Réimír',
    privacyPolicy: 'Polasaí príobháideachta',
    problemLoadingData: 'Earráid agus sonraí á lódáil',
    processing: 'Ag próiseáil',
    purchaseValueCard: 'Ceannaigh cárta luacha',
    readMoreAbout: 'Léigh níos mó faoinár',
    readMoreAndBook: 'Léigh níos mó agus ceannaigh',
    readMoreAndBuy: 'Léigh níos mó agus ceannaigh',
    refillCredits: 'Athlíon creidmheasanna',
    returnToWebsite: 'Fill ar an láithreán gréasáin',
    scanTicket: 'Scannáil ticéad',
    signUp: 'Cláraigh',
    subtract: 'Bain',
    shoesAndHarnessAlwaysIncluded: 'Bróga agus harnais san áireamh i gcónaí.',
    shoesAndHarnessNotIncluded: 'Bróga agus harnais gan a bheith san áireamh.',
    somethingWentWrongUpdatingUserInfo: 'Chuaigh rud éigin amú agus eolas úsáideora á nuashonrú.',
    termsOfUse: {
        template: 'Téarmaí úsáide do <NAME>',
    } as any,
    upcomingBookings: 'Áirithintí atá le teacht',
    updateAddress: 'Nuashonraigh seoladh',
    terminate: 'Críochnaigh',
    thankYouForBookingWithUs: 'Go raibh maith agat as áirithint linn.',
    thePrivacyPolicy: 'Polasaí Príobháideachta',
    thankYouForShoppingWithUs: 'Go raibh maith agat as siopadóireacht linn.',
    thisGiftcardIsEmpty: 'Tá an cárta bronntanais seo folamh.',
    tHours: 'uaireanta',
    totalCredits: 'Creidmheasanna iomlána',
    totalNOK: 'NOK iomlán',
    updateBooking: 'Nuashonraigh áirithint',
    updateProfile: 'Nuashonraigh próifíl',
    useGiftcard: 'Úsáid cárta bronntanais',
    useGiftcardOrPromocode: 'Úsáid cárta bronntanais / cód fóntais',
    validationNotANumber: 'Caithfidh sé a bheith ina uimhir',
    validationMaxNumber: {
        template: 'Níl aon uimhreacha os cionn <NUM>',
    } as any,
    validationMinNumber: {
        template: 'Níl aon uimhreacha faoi bhun <NUM>',
    } as any,
    validForThePeriod: 'Bailí don tréimhse',
    validUntil: 'Bailí go dtí',
    validFrom: 'Bailí ó',
    valueCard: 'Cárta luacha',
    visitors: 'Cuairteoirí',
    withoutVat: 'Gan CBL',
    yes: 'Tá',
    youDontHaveAnyUpcomingBookings: 'Níl aon áirithintí atá le teacht agat.',
    youDontHaveAnyValueCards: 'Níl aon chártaí luacha agat',
    youDontHaveAValidMembershipDoYouWantToPurchaseIt:
        'Níl ballraíocht bhailí agat, an mian leat ceann a cheannach?',
    youMustSpecifyAValueCard: 'Caithfidh tú cárta luacha bailí a shonrú.',
    yourReservationTimedOut: "Tháinig d'áirithint chun deiridh.",
    zipcode: 'Cód poist',
    payByMembershipCard: 'Íoc le cárta ballraíochta',
    payWith: 'Íoc le',
    deleteMyProfile: 'Scrios mo phróifíl',
    areYouSureYouWantToDeleteYourProfile:
        'An bhfuil tú cinnte gur mhaith leat do phróifíl a scriosadh?',
    deleteYourProfileInformation:
        "Tá tú ar tí d'eolas próifíle a scriosadh agus a dhícheangal ó aon áirithintí agus táirgí a ceannaíodh. Ní féidir an gníomh seo a chur ar ceal. D'fhéadfadh roinnt eolais a bheith stóráilte ar chúiseanna dlíthiúla.",
    choosePaymentOtherMethods: 'Roghnaigh modhanna íocaíochta eile',
    dontUseMembershipCardForThisBooking: 'Ná húsáid cárta ballraíochta don áirithint seo',
    nameNotProvided: 'Níl ainm ar fáil',
    phoneNumberNotProvided: 'Níl uimhir fóin ar fáil',
    emailNotProvided: 'Níl ríomhphost ar fáil',
    addressNotProvided: 'Níl seoladh ar fáil',
    promocode: 'Cód fóntais',
    show_usage_terms: 'Taispeáin Téarmaí Úsáide',
    hide_usage_terms: 'Folaigh Téarmaí Úsáide',
    about_the_product: 'faoin táirge',
    successful: 'Rathúil',
    selectProduct: 'Roghnaigh Táirge',
    withCreditCard: 'Le cárta creidmheasa',
    paymentMethod: 'Modh Íocaíochta',
    noAvailableTimeslots: 'Níl aon slotanna ama ar fáil',
    orderReference: 'Tagairt Ordú',
    iWishToRecieveNewsletters: 'Ba mhaith liom nuachtlitreacha a fháil',
    mySite: 'Mo Láithreán',
    pleaseConfirm: {
        template: 'Deimhnigh "<NAME>" le do thoil',
    } as any,
    pleaseProvideNumberOfParticipants: 'Tabhair líon na rannpháirtithe le do thoil',
    pleaseSelectTheDateAndTimeOfYourBooking: "Roghnaigh dáta agus am d'áirithinte le do thoil",
    pleaseSelectNumberOfCredits: 'Roghnaigh líon na gcreidmheasanna le do thoil',
    pleaseSelectTypeOfCreditcard: 'Roghnaigh cineál cárta creidmheasa le do thoil',
    pleaseSelectAStartDate: 'Roghnaigh dáta tosaigh le do thoil',
    pleaseSelectAMembershipType: 'Roghnaigh cineál ballraíochta le do thoil',
    contactCustomerServiceToDeleteYourProfile:
        'Déan teagmháil le seirbhís chustaiméara chun do phróifíl a scriosadh',
    inclInMembership: 'San áireamh sa bhallraíocht',
    maxAmount: 'Uasmhéid',
    checkIn: 'Cláraigh isteach',
    checkOut: 'Cláraigh amach',

    anErrorOccurredDuringPayment: 'Tharla earráid le linn na híocaíochta',
    anErrorOccurredPleaseTryAgainByReloadingThePageErrorMessage:
        'Tharla earráid, déan iarracht arís trí an leathanach a athlódáil. Teachtaireacht earráide',
    share: 'Roinn',
    copyLink: 'Cóipeáil nasc',
    howDoYouWantToShare: 'Conas ba mhaith leat a roinnt?',

    shoppingCart: 'Tralaí siopadóireachta',
    heresMyShoppingCart: 'Seo mo thralaí siopadóireachta',
    thereIsNotEnoughCapacityForTheItemsInThisCart:
        'Níl go leor toilleadh ann do na míreanna sa tralaí seo',

    full: 'Lán',
    no_available_capacity_for_this_tour: 'Níl aon toilleadh ar fáil don turas seo',
    no_availability_for_selected_rooms_and_guests:
        'Níl an líon aíonna seo ar fáil do na dátaí seo — bain triail as níos lú aíonna nó dátaí difriúla.',
    one_or_more_activities_or_accommodations_dont_have_enough_capacity:
        'Níl go leor toilleadh ag gníomhaíocht amháin nó níos mó',

    pick_a_date: 'Roghnaigh dáta',
    package: 'Pacáiste',
    packages: 'Pacáistí',
    customize_activities: 'Saincheap gníomhaíochtaí',
    check_in_at: 'Cláraigh isteach ag',
    activity_starts_at: 'Tosaíonn an ghníomhaíocht ag',
    other_times_are_available: 'Tá amanna eile ar fáil',
    press_to_select_other_options: 'Brúigh chun roghanna eile a roghnú',
    unavailableForSelectedTime: 'Níl ar fáil ag an am roghnaithe',
    order_status_awaiting_payment: 'Ag próiseáil íocaíochta',
    order_status_payment_failed: 'theip ar íocaíocht',
    awaiting_payment_info:
        'Ag próiseáil íocaíochta... de ghnáth ní thógann sé níos mó ná cúpla nóiméad.',
    cancel_membership: 'Cealaigh ballraíocht',
    update_subscription_payment_details: 'Nuashonraigh sonraí íocaíochta',
    payment_failed_info:
        "Is cosúil go bhfuil fadhb le d'íocaíocht. D'fhéadfá iarracht a dhéanamh ar na sonraí íocaíochta a nuashonrú.",
    retry_subscription_payment: 'Déan iarracht ar íocaíocht anois',

    entrance: 'Bealach isteach',
    related_products: 'Táirgí gaolmhara',
    some_tickets_are_unavailable_the_selected_day: 'Níl roinnt ticéad ar fáil an lá roghnaithe',
    company: 'Comhlacht',
    customer_type: 'Cineál custaiméara',
    company_name: 'Ainm comhlachta',
    org_number: 'Uimhir eagraíochta',
    pay_with_invoice: 'Íoc le sonrasc',
    continueWithRebooking: 'Lean ar aghaidh le hath-áirithint',
    searchAndBookAccommodations: 'Cuardaigh agus áirigh lóistín',
    selectNumberOfGuests: 'Roghnaigh líon na n-aíonna',
    checkAvailability: 'Seiceáil argaeledd',
    updateAvailability: 'Nuashonraigh argaeledd',
    you_will_have_to_switch_rooms_during_your_stay:
        "Beidh ort seomraí a athrú le linn d'fhanachta. Déan teagmháil linn chun leanúint ar aghaidh leis an áirithint.",
    selected: 'Roghnaithe',
    remove: 'Bain',
    empty_cart: 'Folmhaigh tralaí',
    aria_increase: 'Méadaigh',
    aria_decrease: 'Laghdaigh',
    promo_code_not_supported_for_gift_cards:
        'Ní thacaítear leis an gcód fóntais do chártaí bronntanais',
    select_products: 'Roghnaigh táirgí',
    change_selected_products: 'Athraigh táirgí roghnaithe',
    see_available_tickets: 'Féach ar thicéad ar fáil',
    waiting_list: 'Liosta Feithimh',
    join_waiting_list: 'Bí páirteach sa Liosta Feithimh',
    no_waiting_list_items_found: 'Níor aimsíodh aon mhíreanna liosta feithimh sa tralaí',
    waiting_list_notification_message: 'Cuirfimid in iúl duit nuair a bheidh spotaí ar fáil',

    waiting_list_what_happens_next: 'Cad a tharlaíonn ar aghaidh?',
    waiting_list_next_steps:
        "Monreóimid argaeledd do do mhíreanna roghnaithe|Gheobhaidh tú ríomhphost nuair a osclóidh spotaí|Lean an nasc sa ríomhphost chun d'áirithint a chríochnú",
    product_required_for_function: {
        template: 'Tá táirge ag teastáil do <NAME>, fuarthas: <NAME>',
    } as any,
    giftcard_cannot_be_used_with_deposit_payment:
        'Ní féidir cártaí bronntanais a úsáid le híocaíochtaí blaendail',
};

export default translations;
